import { Component, ElementRef, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { IModalOptions } from '../../../gamma/modal';
import { LogicalUnitModalBaseComponent } from '../../../gamma/logicalunit/logicalunit-modal-base.component';
import { ModalDismissGuard } from '../../../gamma/modal/modal-dismiss.guard';
import { RoutingService } from '../../../gamma/routing';
import { ToastService } from '../../../gamma/toast';
import { UserAgentService } from '../../../gamma/utils';

import { U2021_EulaService } from '../../U2021_eula/U2021_eula.service';

@Component({
    selector: 'u2021-eula-modal',
    templateUrl: 'U2021_eula-modal.component.html',
    styleUrls: ['U2021_eula-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class U2021_EulaModalComponent extends LogicalUnitModalBaseComponent<U2021_EulaService, boolean> implements OnInit, OnDestroy {
    // Read by U2000_ModalProvider before the modal is created (size/backdrop can no longer be
    // mutated from this component's own constructor under ngx-bootstrap — see U2000_modal.provider.ts).
    static readonly modalDisplayOptions: IModalOptions = { size: 'large', backdrop: true };

    private iframe: HTMLIFrameElement;

    constructor(
        service: U2021_EulaService,
        public dialog: BsModalRef,
        // Super requirements
        toastService: ToastService,
        routingService: RoutingService,
        modalDismissGuard: ModalDismissGuard,

        public userAgentService: UserAgentService,
        private el: ElementRef,
    ) {
        super(service, dialog, toastService, routingService, modalDismissGuard);
    }

    override ngOnInit() {
        super.ngOnInit();
        const element: HTMLDivElement = this.el.nativeElement;
        this.iframe = element.getElementsByTagName('iframe')[0];
        const modalDialog = element.parentElement.parentElement;
        const modalContent = element.parentElement;

        modalDialog.classList.add('u2021-eula-dialog');
        modalContent.classList.add('u2021-eula-content');

        this.iframe.src = this.service.luConfigs.url;
    }

    override ngOnDestroy() {
        super.ngOnDestroy();
    }

    closeClick() {
        this.result = true;
        this.dialog.hide();
    }
}
